<script>
import NavSection from './components/NavSection.vue'
import EventNavSection from './components/EventNavSection.vue'
import HeaderSection from './components/HeaderSection.vue'

export default {
  name: 'App',
  data(){
    return {
      PageLayout:"default"
    }
  },/*
  provide() {
    return {
      loading: this.loading
    };
  },  */
    isLoading(){
      return this.loading;
    } , 
  components: {
    NavSection,
    HeaderSection,
    EventNavSection
  },
  watch: {
    '$route' (to, ) { 
      document.title = "Workshopix";
      this.layoutChanged(to);
      if(this.$refs.NavSection){
        
        this.navBarCloseMobile();
      }
      
     
    }
  }, 
  mounted(){
      

      this.layoutChanged(this.$route); 
      this.checkExpireTime();  
  },
  methods:{
    navBarCloseMobile(){
      const tog = document.getElementById("MyNavbar");
      if ( window.innerWidth < 992 &&  tog.classList.contains("show") ) {    
          const btn=document.getElementById("navbar-toggler")
          btn.click();
      }     
    },
    layoutChanged(route){
      this.PageLayout = route.meta.layout;
      //this.PageLayout = "Default";
    },
    checkExpireTime(){
      const t0=localStorage.getItem("expire_time");
      const t1 = Math.floor(Date.now() / 1000);
      if(t0<=t1){
        this.$router.push({name:"Login"});
      }
    }
  }
}
</script>

<style>

  .left-menu {
      min-height: 100vh;

  }
  :root {
     --wpx-primary:#3a9985;
  }
  @media screen and (min-width: 768px) {
    .ql-editor{
        min-height:200px;
    } 
  }
  @media screen and (max-width: 768px) {
    .ql-editor{
        min-height: 500px;
    } 
  }  
  .list_table{
    border-top: 10px solid var(--wpx-primary) !important;
  }
</style>
<template>
  <div id="app">
  
    <div v-if="PageLayout=='Default'">
      <HeaderSection />
      <div class="main container-fluid">
        <div class="row flex-wrap">
          <div class=" col-md-3 col-lg-2 col-xxl-2 p-0 bg-dark d-flex flex-column align-items-stretch sticky-top collapse" id="sidebar">
            <NavSection ref="NavSection" class="left-menu" />
          </div>
          <div class="col-md-9 col-lg-10 col-xxl-10 bg-light">  
            <router-view :key="$route.fullPath"></router-view>
          </div>
        </div>  
      </div> 
   </div>
    <div v-else-if="PageLayout=='Event'">
      <HeaderSection />
      <div class="main container-fluid">
        <div class="row flex-wrap">
          <div class=" col-md-3 col-lg-2 col-xxl-2 p-0 bg-dark d-flex flex-column align-items-stretch sticky-top collapse" id="sidebar">
            <EventNavSection class="left-menu" />
          </div>
          <div class="col-md-9 col-lg-10 col-xxl-10 bg-light">  
            <router-view />
          </div>
        </div>  
      </div> 
   </div>   
   <div v-else-if="PageLayout=='NotFound'">
    <router-view :key="$route.fullPath" />
   </div> 
   
   <div v-else-if="PageLayout=='Login'">
    <router-view :key="$route.fullPath" />
   </div>   
  </div>
  
</template>